import { heatRank } from '@/mocks/home';

export default function HeatStrip() {
  const loop = [...heatRank, ...heatRank];

  return (
    <section className="border-y border-foreground-800 bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-12 max-w-[1440px] items-center gap-4 px-4 md:h-14 md:px-8">
        <span className="flex flex-none items-center gap-2 border-r border-background-50/15 pr-4">
          <i className="ri-fire-line text-lg text-accent-500" />
          <span className="whitespace-nowrap font-heading text-sm font-bold">实时热度榜</span>
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max items-center gap-8 hl-marquee">
            {loop.map((item, index) => (
              <span key={`${item.term}-${index}`} className="flex items-center gap-2 whitespace-nowrap">
                <span
                  className={`font-label text-sm font-semibold ${
                    item.rank <= 3 ? 'text-accent-500' : 'text-background-400'
                  }`}
                >
                  {String(item.rank).padStart(2, '0')}
                </span>
                <span className="text-sm text-background-100">{item.term}</span>
                <span className="flex items-center gap-1 text-xs text-background-400">
                  <i className="ri-line-chart-line text-sm" />
                  {item.heat}
                </span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#rank"
          className="hidden flex-none items-center gap-1 whitespace-nowrap text-xs text-background-300 transition-colors hover:text-accent-500 md:flex"
        >
          完整榜单
          <i className="ri-arrow-right-s-line text-base" />
        </a>
      </div>
    </section>
  );
}